import React from 'react';
import { useMediaQuery } from 'react-responsive';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';

const twConfig = resolveConfig(tailwindConfig);

export const randomId = () => {
  return Math.random().toString(32).slice(2);
};

export const devOrProd = process.env.REACT_APP_DEVORPROD;

export const nuqliumDataIndexSeven = () => {
  if (devOrProd === 'dev') {
    return '100042';
  }
  if (devOrProd === 'prod') {
    return '100052';
  }
};

export const getFormData = (object) => {
  const formData = new FormData();
  Object.keys(object).forEach((key) => formData.append(key, object[key]));
  return formData;
};

export const renderHTML = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

export const renderHTMLspan = (rawHTML, className = null) => {
  // Render HTML in JSON
  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: rawHTML }} />
  );
};

const getCookieValue = (a) => {
  var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
};

export const getInternationalPriceNuqlium = () => {
  switch (getCookieValue('currencypref')) {
    case 'GBP':
      return 'retail_gbp';
    case 'EUR':
      return 'retail_eur';
    case 'USD':
      return 'retail_usd';
    case 'AUD':
      return 'retail_aud';
    case 'JPY':
      return 'retail_jpy';
    case 'CNY':
      return 'retail_cny';
    case 'HKD':
      return 'retail_hkd';
    default:
      return 'retail_gbp';
  }
};

export const randomString = () => {
  return Math.random().toString(36).substring(7);
};

export const getBreakpoint = (query) => {
  return parseInt(twConfig.theme.screens[query].replace('px', ''));
};

export const getPreviousBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  if (query === 'sm') return 0;
  const prevBreakpoint = keys[keys.indexOf(query) - 1];
  return getBreakpoint(prevBreakpoint);
};

export const getNextBreakpoint = (query) => {
  const keys = Object.keys(twConfig.theme.screens);
  const nextBreakpoint = keys[keys.indexOf(query) + 1];
  return getBreakpoint(nextBreakpoint);
};

export const useTailwindMediaQuery = (query) => {
  const breakpoint = getBreakpoint(query);

  return useMediaQuery({ maxWidth: breakpoint });
};
